var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("configuration.BoxWrap.manage") } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "FPermission",
                  rawName: "v-FPermission",
                  value: { pageName: _vm.pageName, list: ["LIST"] },
                  expression: "{pageName, list: ['LIST']}",
                },
              ],
              staticClass: "action-container",
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    size: "small",
                    inline: "",
                    "label-width": "80px",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    {
                      staticClass: "row-bg",
                      attrs: { type: "flex", justify: "space-between" },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("configuration.input.fieldCode"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "configuration.input.holder"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchVal.configItemCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.searchVal,
                                      "configItemCode",
                                      $$v
                                    )
                                  },
                                  expression: "searchVal.configItemCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "configuration.input.configItemName"
                                ),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "configuration.input.holder"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchVal.configItemName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.searchVal,
                                      "configItemName",
                                      $$v
                                    )
                                  },
                                  expression: "searchVal.configItemName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "configuration.input.configurationType"
                                ),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "configuration.input.optionHolder"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.searchVal.configItemType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchVal,
                                        "configItemType",
                                        $$v
                                      )
                                    },
                                    expression: "searchVal.configItemType",
                                  },
                                },
                                _vm._l(
                                  _vm.lookupList["CONFIGURATION_TYPE"],
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "row-bg",
                      attrs: { type: "flex", justify: "space-between" },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "configuration.input.enableStatus"
                                ),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "configuration.input.optionHolder"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.searchVal.configItemStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchVal,
                                        "configItemStatus",
                                        $$v
                                      )
                                    },
                                    expression: "searchVal.configItemStatus",
                                  },
                                },
                                _vm._l(
                                  _vm.lookupList["CONFIGURATION_STATUS"],
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "wrap-bottom-right" }, [
            _c(
              "div",
              { staticClass: "wrap-bottom-right-btn" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["LIST"] },
                        expression: "{pageName, list: ['LIST']}",
                      },
                    ],
                    attrs: { size: "small", icon: "el-icon-refresh" },
                    on: { click: _vm.resetData },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.reset")))]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["LIST"] },
                        expression: "{pageName, list: ['LIST']}",
                      },
                    ],
                    staticClass: "t-search-btn",
                    attrs: { size: "small", icon: "el-icon-search" },
                    on: { click: _vm.searchData },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.search")))]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("configuration.BoxWrap.list") },
        },
        [
          _c(
            "div",
            { attrs: { slot: "header-right" }, slot: "header-right" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["ADD_VALUE"] },
                      expression: "{pageName, list: ['ADD_VALUE']}",
                    },
                  ],
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.addConfiguration("下拉值")
                    },
                  },
                },
                [_vm._v("新增下拉值")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["ADD_VALUE"] },
                      expression: "{pageName, list: ['ADD_VALUE']}",
                    },
                  ],
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.addConfiguration("值")
                    },
                  },
                },
                [_vm._v("新增值")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  type: "index",
                  index: _vm.tableIndex,
                  label: _vm.$t("lookup.table.sequence"),
                  width: "80",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "configItemCode",
                  label: _vm.$t("configuration.table.fieldCode"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "configItemName",
                  label: _vm.$t("configuration.table.configItemName"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "configItemType",
                  label: _vm.$t("configuration.table.configurationType"),
                  "min-width": "80",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                (_vm.lookupList["CONFIGURATION_TYPE_MAPPING"] &&
                                  _vm.lookupList["CONFIGURATION_TYPE_MAPPING"][
                                    scope.row.configItemType
                                  ]) ||
                                  scope.row.configItemType
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "stringItemDetailVal",
                  label: _vm.$t("configuration.table.configurationValues"),
                  "min-width": "260",
                  align: "left",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "configItemStatus",
                  label: _vm.$t("configuration.table.enableStatus"),
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "small",
                              type:
                                scope.row.configItemStatus === "ENABLED"
                                  ? "success"
                                  : "info",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  (_vm.lookupList[
                                    "CONFIGURATION_STATUS_MAPPING"
                                  ] &&
                                    _vm.lookupList[
                                      "CONFIGURATION_STATUS_MAPPING"
                                    ][scope.row.configItemStatus]) ||
                                    scope.row.configItemStatus
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "lastUpdateTime",
                  label: _vm.$t("configuration.table.enableTime"),
                  align: "left",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("configuration.table.action"),
                  fixed: "right",
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click", size: "medium" } },
                          [
                            _c("el-button", {
                              staticClass: "t-square-btn t-more-btn",
                              attrs: {
                                type: "danger",
                                size: "mini",
                                icon: "el-icon-more",
                                circle: "",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    directives: [
                                      {
                                        name: "FPermission",
                                        rawName: "v-FPermission",
                                        value: {
                                          pageName: _vm.pageName,
                                          list: ["ADD_EDIT"],
                                        },
                                        expression:
                                          "{pageName, list: ['ADD_EDIT']}",
                                      },
                                    ],
                                    staticClass: "t-square-btn t-green-btn",
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      circle: "",
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.edit(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.edit")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    directives: [
                                      {
                                        name: "FPermission",
                                        rawName: "v-FPermission",
                                        value: {
                                          pageName: _vm.pageName,
                                          list: ["ENABLE_DISABLED"],
                                        },
                                        expression:
                                          "{pageName, list: ['ENABLE_DISABLED']}",
                                      },
                                    ],
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.updateStatus(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.configItemStatus === "ENABLED"
                                          ? _vm.$t(
                                              "configuration.common.DISABLED"
                                            )
                                          : _vm.$t(
                                              "configuration.common.ENABLED"
                                            )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            width: "840px",
            form: _vm.form,
            "init-form": _vm.initForm,
            "is-show": _vm.isShowModel,
            "dialog-status": _vm.dialogStatus,
            "save-item": _vm.saveItem,
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowModel = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowModel = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: {
                "label-position": "left",
                model: _vm.form,
                rules: _vm.rules,
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 40 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("configuration.form.fieldCode"),
                            "label-width": _vm.formLabelWidth,
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              disabled: _vm.configuraType !== "add",
                            },
                            model: {
                              value: _vm.form.configItem.configItemCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.configItem,
                                  "configItemCode",
                                  $$v
                                )
                              },
                              expression: "form.configItem.configItemCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "configItem.configItemName",
                            label: _vm.$t("configuration.form.configItemName"),
                            "label-width": _vm.formLabelWidth,
                            rules: _vm.rules.configItemName,
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { autocomplete: "off" },
                            model: {
                              value: _vm.form.configItem.configItemName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.configItem,
                                  "configItemName",
                                  $$v
                                )
                              },
                              expression: "form.configItem.configItemName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "model-header-title" },
                [
                  _c("span", { staticClass: "header-title-txt" }, [
                    _vm._v(
                      _vm._s(_vm.$t("configuration.common.configurationValue"))
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.configItem.configItemType == "下拉值"
                    ? _c(
                        "el-button",
                        {
                          staticClass: "add-button",
                          staticStyle: { float: "left" },
                          attrs: { size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.addValue(_vm.form)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("configuration.common.addValue"))
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.configItem.configItemType === "值"
                ? [
                    _c(
                      "div",
                      {
                        staticStyle: { width: "100%", "margin-bottom": "20px" },
                      },
                      _vm._l(
                        _vm.form.configItemDetailMultiValVoList,
                        function (
                          configItemDetailMultiValVoItem,
                          configItemDetailMultiValVoIndex
                        ) {
                          return _c(
                            "el-row",
                            {
                              key: configItemDetailMultiValVoIndex,
                              attrs: { gutter: 40 },
                            },
                            _vm._l(_vm.languageAllData, function (item, index) {
                              return _c(
                                "el-col",
                                {
                                  key: index,
                                  attrs: {
                                    span:
                                      24 /
                                      (_vm.languageAllData &&
                                        _vm.languageAllData.length),
                                  },
                                },
                                _vm._l(
                                  configItemDetailMultiValVoItem.detailLanguageValList,
                                  function (j, k) {
                                    return _c("div", { key: k }, [
                                      item.languageCode === j.language
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    "label-width": "80px",
                                                    label:
                                                      _vm.$t(
                                                        "configuration.form.value"
                                                      ) +
                                                      "(" +
                                                      item.languageCode +
                                                      ")",
                                                    prop:
                                                      "configItemDetailMultiValVoList." +
                                                      configItemDetailMultiValVoIndex +
                                                      ".detailLanguageValList." +
                                                      k +
                                                      ".value",
                                                    rules: {
                                                      required: true,
                                                      trigger: ["blur"],
                                                      validator:
                                                        _vm.languageMappingHandleClick()[
                                                          item.languageCode
                                                        ],
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      autocomplete: "off",
                                                    },
                                                    model: {
                                                      value: j.value,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          j,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "j.value",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ])
                                  }
                                ),
                                0
                              )
                            }),
                            1
                          )
                        }
                      ),
                      1
                    ),
                  ]
                : [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.formLoading,
                            expression: "formLoading",
                          },
                        ],
                        staticClass: "valueConfig",
                        staticStyle: { width: "100%", "margin-bottom": "20px" },
                        attrs: {
                          "max-height": "240",
                          "highlight-current-row": "",
                          "tooltip-effect": "dark",
                          data: _vm.form.configItemDetailMultiValVoList,
                        },
                        on: { "cell-dblclick": _vm.celldblclick },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "index",
                            index: _vm.tableIndex,
                            label: _vm.$t("configuration.table.systemPk"),
                            align: "left",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("configuration.form.configItemName"),
                            align: "left",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "configItemDetailMultiValVoList." +
                                          scope.$index +
                                          ".itemDetailCode",
                                        rules: _vm.rules.itemDetailCode,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { autocomplete: "off" },
                                        model: {
                                          value: scope.row.itemDetailCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "itemDetailCode",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.itemDetailCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.languageAllData, function (item, index) {
                          return [
                            item.languageStatus === "ENABLED"
                              ? _c("el-table-column", {
                                  key: index,
                                  attrs: {
                                    label:
                                      _vm.$t("configuration.form.value") +
                                      "(" +
                                      item.languageCode +
                                      ")",
                                    align: "left",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return _vm._l(
                                            scope.row.detailLanguageValList,
                                            function (j, k) {
                                              return _c("div", { key: k }, [
                                                item.languageCode === j.language
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              prop:
                                                                "configItemDetailMultiValVoList." +
                                                                scope.$index +
                                                                ".detailLanguageValList." +
                                                                k +
                                                                ".value",
                                                              rules: {
                                                                required: true,
                                                                trigger: [
                                                                  "blur",
                                                                ],
                                                                validator:
                                                                  _vm.languageMappingHandleClick()[
                                                                    item
                                                                      .languageCode
                                                                  ],
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                autocomplete:
                                                                  "off",
                                                              },
                                                              model: {
                                                                value: j.value,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      j,
                                                                      "value",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "j.value",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ])
                                            }
                                          )
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              : _vm._e(),
                          ]
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("configuration.table.sort"),
                            fixed: "right",
                            align: "left",
                            "min-width": "80",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "configItemDetailMultiValVoList." +
                                          scope.$index +
                                          ".itemDetailSn",
                                        rules: _vm.rules.validateItemDetailSn,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "80px" },
                                        attrs: {
                                          maxlength: "6",
                                          autocomplete: "off",
                                        },
                                        model: {
                                          value: scope.row.itemDetailSn,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "itemDetailSn",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.itemDetailSn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("configuration.table.action"),
                            fixed: "right",
                            align: "left",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-button", {
                                    directives: [
                                      {
                                        name: "FPermission",
                                        rawName: "v-FPermission",
                                        value: {
                                          pageName: _vm.pageName,
                                          list: ["ADD_EDIT"],
                                        },
                                        expression:
                                          "{pageName, list: ['ADD_EDIT']}",
                                      },
                                    ],
                                    staticClass: "t-square-btn ",
                                    attrs: {
                                      size: "mini",
                                      icon: "el-icon-delete",
                                      circle: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteValue(scope.$index)
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      2
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }